import React from 'react';
import SetDefaultEmailFrequency from './SetDefaultEmailFrequency';

const EmailFrequencyComponent = ({ user, motor }) => {
  return (
    <div className="bg-white border border-gray-200 shadow-lg rounded-lg p-6 sm:p-8 mb-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-indigo-400 flex items-center justify-center shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-white" viewBox="0 0 20 20" fill="currentColor">
            <path d="M2.94 6.94a.75.75 0 011.06 0L10 12.94l6-6a.75.75 0 111.06 1.06l-6.53 6.53a.75.75 0 01-1.06 0L2.94 8a.75.75 0 010-1.06z" />
            <path d="M2 5.75A1.75 1.75 0 013.75 4h12.5A1.75 1.75 0 0118 5.75v8.5A1.75 1.75 0 0116.25 16H3.75A1.75 1.75 0 012 14.25v-8.5zm1.75-.25a.25.25 0 00-.25.25v.4l6.5 4.15 6.5-4.15v-.4a.25.25 0 00-.25-.25H3.75z" />
          </svg>
        </div>
        <h2 className="text-xl sm:text-2xl font-semibold text-gray-800">Fréquence des mails</h2>
      </div>
      <SetDefaultEmailFrequency token={user.token} motor={motor} />
    </div>
  );
};

export default EmailFrequencyComponent;